import {useSyncExternalStore} from 'react';

import type {HighlightSource} from '../../state/interactState/highlightSource';
import type {Highlight} from '../../state/interactState/types';

function noop() {}

function subscribeNever() {
  return noop;
}

/**
 * Reads one highlight axis from the source while on screen. Off screen it
 * reads nothing and never re-renders, like useInteractStateWhenOnScreen. The
 * value is a primitive, so the component re-renders only when this axis
 * changes.
 */
export function useHighlightValue(
  source: HighlightSource,
  axis: string,
  onScreen: boolean
): Highlight[string] {
  function readAxis() {
    return onScreen ? source.get()[axis] : undefined;
  }
  return useSyncExternalStore(
    onScreen ? source.subscribe : subscribeNever,
    readAxis
  );
}
